import React from "react";
import ReactDOM from "react-dom";
import { Route, BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "antd/dist/antd.css";
import "./index.css";
// import { Provider } from "react-redux";
// import store from "./Public/Redux/store";

const EnhancedApp = () => {
  return (
    // redux
    // <Provider store={store}>
    <Router>
      <div>
        <Route path="/" exact component={App} />
      </div>
    </Router>
    // </Provider>
  );
};
ReactDOM.render(<EnhancedApp />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
